import { RemixBrowser, useLocation, useMatches } from '@remix-run/react'
import * as Sentry from '@sentry/remix'
import i18next from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
import { startTransition, StrictMode, useEffect } from 'react'
import { hydrateRoot } from 'react-dom/client'
import { I18nextProvider, initReactI18next } from 'react-i18next'
import { getInitialNamespaces } from 'remix-i18next/client'

import i18n from '~/translations/i18n'

// @ts-expect-error We set ENV in root.tsx
const { SENTRY_DSN, NODE_ENV, APP_VERSION } = window.ENV || {
  SENTRY_DSN: '',
  NODE_ENV: 'development',
  APP_VERSION: '0.0.0'
}
const enabled = NODE_ENV === 'production'

Sentry.init({
  dsn: SENTRY_DSN,
  enabled,
  release: APP_VERSION,
  tracesSampleRate: 1,
  integrations: [
    Sentry.browserTracingIntegration({
      useEffect,
      useLocation,
      useMatches
    }),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true
    })
  ],

  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1
})

async function hydrate() {
  await i18next
    .use(initReactI18next)
    .use(LanguageDetector)
    .use(Backend)
    .init({
      ...i18n,
      ns: getInitialNamespaces(),
      backend: {
        loadPath: `/locales/{{lng}}/{{ns}}.json?v=${APP_VERSION}`
      },
      detection: {
        order: ['htmlTag'],
        caches: []
      }
    })

  startTransition(() => {
    hydrateRoot(
      document,
      <I18nextProvider i18n={i18next}>
        <StrictMode>
          <RemixBrowser />
        </StrictMode>
      </I18nextProvider>
    )
    // @ts-expect-error - window.hydration_observer is defined in root.tsx
    window.hydration_observer.disconnect()
  })
}

if (window.requestIdleCallback) {
  window.requestIdleCallback(hydrate)
} else {
  // Safari doesn't support requestIdleCallback
  // <https://caniuse.com/requestidlecallback>
  window.setTimeout(hydrate, 1)
}
